/**
 * Cartes produit dynamiques pour les articles de blog.
 *
 * Contrat d'écriture (dans le corps de l'article) :
 * <div class="blog-product-card-v2"
 *      data-product-handle="handle-du-produit"
 *      data-badge="★ Recommandé dans ce guide"
 *      data-context="Une phrase de contexte éditoriale."
 *      data-benefits="Point 1|Point 2|Point 3"
 *      data-rating="4.97"
 *      data-rating-count="30"
 *      data-fallback-collection="/collections/tous-les-harnais-chien"
 * ></div>
 *
 * Au chargement de la page, ce script va chercher les données live du produit
 * (photo, prix, disponibilité) via l'endpoint public Shopify /products/{handle}.js
 * et construit la carte. Si le produit n'existe plus (404) ou n'est plus
 * disponible, la carte est remplacée par un repli propre plutôt que de laisser
 * un lien ou une image cassée.
 */
(function () {
  function formatPrice(cents) {
    if (cents == null) return '';
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function buildStars(rating) {
    var r = Math.round(parseFloat(rating) || 0);
    return '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r);
  }

  function renderFallback(el) {
    var fallbackUrl = el.getAttribute('data-fallback-collection') || '/collections/tous-les-harnais-chien';
    el.innerHTML =
      '<div class="bpc-fallback" style="padding:1.6rem;border:1px dashed #ccc;border-radius:8px;text-align:center;">' +
      '<p style="margin:0 0 .8rem;">Ce produit n\'est plus disponible pour le moment.</p>' +
      '<a href="' + fallbackUrl + '" class="bpc-cta">Voir notre sélection →</a>' +
      '</div>';
  }

  function renderCard(el, product) {
    var badge = el.getAttribute('data-badge') || '★ Recommandé dans ce guide';
    var context = el.getAttribute('data-context') || '';
    var benefits = (el.getAttribute('data-benefits') || '').split('|').filter(Boolean);
    var rating = el.getAttribute('data-rating');
    var ratingCount = el.getAttribute('data-rating-count');
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var price = formatPrice(product.price);
    var comparePrice = product.compare_at_price && product.compare_at_price > product.price
      ? formatPrice(product.compare_at_price)
      : '';

    var benefitsHtml = benefits.map(function (b) {
      return '<li><span class="bpc-check">✓</span>' + b + '</li>';
    }).join('');

    var ratingHtml = rating
      ? '<p class="bpc-rating"><span class="bpc-stars">' + buildStars(rating) + '</span>' + rating + '/5' +
        (ratingCount ? ' • ' + ratingCount + ' avis' : '') + '</p>'
      : '';

    el.innerHTML =
      '<a href="' + product.url + '" class="bpc-img-wrap">' +
      '<img src="' + img + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" class="bpc-img" loading="lazy">' +
      '<img src="https://cdn.shopify.com/s/files/1/0992/8553/3046/files/hce-badge-selection-seal.png?v=1783849715" alt="Sélection Harnais Chien Expert" class="bpc-badge" loading="lazy">' +
      '</a>' +
      '<div class="bpc-content">' +
      '<span class="bpc-pill">' + badge + '</span>' +
      '<a href="' + product.url + '" class="bpc-title-link"><p class="bpc-title">' + product.title + '</p></a>' +
      (context ? '<p class="bpc-context">' + context + '</p>' : '') +
      (benefitsHtml ? '<ul class="bpc-benefits">' + benefitsHtml + '</ul>' : '') +
      ratingHtml +
      '<hr class="bpc-divider">' +
      '<div class="bpc-footer">' +
      '<span class="bpc-price">' + price + (comparePrice ? '<span class="bpc-price-compare">' + comparePrice + '</span>' : '') + '</span>' +
      '<a href="' + product.url + '" class="bpc-cta">Voir le produit →</a>' +
      '</div>' +
      '</div>';
  }

  function init() {
    var cards = document.querySelectorAll('.article-template__content .blog-product-card-v2[data-product-handle]');
    cards.forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle) return;
      fetch('/products/' + handle + '.js')
        .then(function (resp) {
          if (!resp.ok) throw new Error('product not found');
          return resp.json();
        })
        .then(function (product) {
          if (!product.available && product.available !== undefined) {
            // Product exists but is out of stock / unpublished from this context: still show it,
            // availability alone shouldn't hide a valid, purchasable-later product page.
          }
          renderCard(el, product);
        })
        .catch(function () {
          renderFallback(el);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
